import { render, staticRenderFns } from "./AdminAreasDeleteButton.vue?vue&type=template&id=7eda120f"
import script from "./AdminAreasDeleteButton.vue?vue&type=script&lang=js"
export * from "./AdminAreasDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports